<template>
  <div class="contact-page">
    <!-- 顶部图片 -->
    <section class="hero-section">
      <img src="@/assets/contact/hero.png" alt="展示图" class="hero-image" />
    </section>

    <!-- 右侧整体区域：左边标题+图片，右边表单 -->
    <section class="content-wrapper">
      <div class="right-wrapper">
        <!-- 左栏：标题+图片 -->
        <div class="info-panel">
          <h1>公司总部</h1>
          <img src="@/assets/contact/left-show.png" alt="信息展示图" class="info-image" />
        </div>

        <!-- 右栏：表单 -->
        <div class="form-section">
          <h1>业务需求</h1>
          <form @submit.prevent="handleSubmit">
            <div class="form-row">
              <div class="form-item">
                <label for="name">姓名</label>
                <input id="name" type="text" v-model="form.name" placeholder="请输入您的姓名" required />
              </div>
              <div class="form-item">
                <label for="title">职务</label>
                <input id="title" type="text" v-model="form.title" placeholder="请输入您的职务" />
              </div>
            </div>

            <div class="form-row">
              <div class="form-item">
                <label for="company">公司</label>
                <input id="company" type="text" v-model="form.company" placeholder="请输入公司名称" />
              </div>
              <div class="form-item">
                <label for="city">城市</label>
                <input id="city" type="text" v-model="form.city" placeholder="请输入您所在的城市" />
              </div>
            </div>

            <div class="form-row">
              <div class="form-item">
                <label for="phone">电话</label>
                <input id="phone" type="text" v-model="form.phone" placeholder="请输入您的电话" required />
              </div>
              <div class="form-item">
                <label for="email">邮箱</label>
                <input id="email" type="email" v-model="form.email" placeholder="请输入您的邮箱" required />
              </div>
            </div>

            <div class="form-item rich full-width">
              <label for="description">业务需求描述</label>
              <div class="rich-editor-wrapper">
                <div
                  id="description"
                  class="rich-editor"
                  contenteditable="true"
                  @input="updateDescription"
                  @focus="onFocus"
                  @blur="onBlur"
                  ref="richEditor"
                  :class="{ empty: isDescriptionEmpty }"
                ></div>
                <div v-if="isDescriptionEmpty" class="placeholder-text" @click="focusEditor">
                  请简要描述您的业务需求
                </div>
              </div>
            </div>

            <!-- 图片按钮提交 -->
            <div class="btn-wrapper">
              <button type="submit" class="submit-btn img-btn" aria-label="提交需求">
                <img src="@/assets/contact/submit.png" alt="提交需求" class="submit-img" />
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: '',
        title: '',
        company: '',
        city: '',
        phone: '',
        email: '',
        description: '',
      },
      isDescriptionEmpty: true,
    }
  },
  methods: {
    updateDescription(event) {
      const html = event.target.innerHTML.trim()
      const text = event.target.innerText.trim()
      this.isDescriptionEmpty = text === ''
      this.form.description = html
    },
    onFocus() {
      this.isDescriptionEmpty = false
    },
    onBlur(event) {
      const text = event.target.innerText.trim()
      this.isDescriptionEmpty = text === ''
      if (this.isDescriptionEmpty) {
        this.form.description = ''
      }
    },
    focusEditor() {
      this.$refs.richEditor.focus()
    },
    handleSubmit() {
      if (this.isDescriptionEmpty) {
        alert('请填写业务需求描述')
        this.focusEditor()
        return
      }
      console.log('提交数据：', this.form)
      //alert('提交成功！')
      this.form = {
        name: '',
        title: '',
        company: '',
        city: '',
        phone: '',
        email: '',
        description: '',
      }
      this.isDescriptionEmpty = true
      this.$refs.richEditor.innerHTML = ''
    },
  },
}
</script>

<style scoped>
/* 根字体大小可根据需要调整 */
/* 也可以放到全局 */
html {
  font-size: 16px;
}

.contact-page {
  font-family: sans-serif;
  min-height: 150vh;
  display: flex;
  flex-direction: column;
}

/* 顶部图片 */
.hero-section {
  width: 100%;
}
.hero-image {
  width: 100%;
  display: block;
}

/* 内容宽度限制，百分比+max-width */
.content-wrapper {
  flex: 1;
  width: 90vw;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
  display: flex;
  justify-content: center;
}

/* 右侧整体左右两栏 */
.right-wrapper {
  display: flex;
  gap: 3vw; /* 横向间距用vw单位响应屏幕宽度 */
  width: 100%;
  align-items: flex-start;
}

/* 左栏：标题 + 图片 */
.info-panel {
  width: 35%;
  margin-left: 0; /* 移除固定留白，留给content-wrapper控制 */
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
  text-align: left;
}

.info-panel h1 {
  width: 100%;
  font-size: clamp(24px, 2.5vw, 35px);
}

.info-image {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: none;
  border-radius: 8px;
  object-fit: unset;
}

/* 右栏：表单 */
.form-section {
  width: 65%; /* 和左栏加起来100% */
  margin-right: 0;
  display: flex;
  flex-direction: column;

}

.form-section h1 {
  width: 100%;
  font-size: clamp(24px, 2.5vw, 35px);
}

/* 表单结构 */
form {
  display: flex;
  flex-direction: column;
  gap: 3rem;
}

.form-row {
  margin-top: 1.25rem;
  display: flex;
  gap: 2vw;
}

.form-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.full-width {
  width: 100%;
}

.form-item.rich {
  margin-top: 0.625rem;
}

.form-item label {
  font-weight: bold;
  font-size: clamp(18px, 2vw, 25px);
  margin-bottom: 0.375rem;
  color: #333;
}

.form-item input {
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: clamp(16px, 1.8vw, 20px);
  outline: none;
  transition: border-color 0.3s ease;
}

.form-item input:focus {
  border-color: #409eff;
}

/* 富文本编辑器 */
.rich-editor-wrapper {
  flex: 1;
  position: relative;
}

.rich-editor {
  min-height: clamp(200px, 30vh, 350px);
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 0.625rem;
  background-color: white;
  font-size: clamp(16px, 1.8vw, 20px);
  line-height: 1.6;
  overflow-y: auto;
  outline: none;
  transition: border-color 0.3s ease;
}

.rich-editor:focus {
  border-color: #409eff;
}

.rich-editor.empty {
  color: transparent;
}

.placeholder-text {
  position: absolute;
  top: 0.625rem;
  left: 0.75rem;
  font-size: clamp(16px, 1.8vw, 20px);
  color: #aaa;
  pointer-events: none;
}

/* 图片按钮样式 */
.btn-wrapper {
  display: flex;
  justify-content: center;
}

.submit-btn {
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
}

.submit-img {
  height: 3.125rem; /* 50px */
  width: auto;
  transition: opacity 0.2s, transform 0.2s;
}

.submit-img:hover,
.submit-img:focus {
  opacity: 0.85;
  transform: scale(1.03);
}

/* 响应式调整 */
@media screen and (max-width: 1024px) {
  .right-wrapper {
    gap: 2vw;
  }
}

@media screen and (max-width: 768px) {
  .content-wrapper {
    width: 95vw;
    transform: none; /* 移除偏移 */
    padding: 1.5rem 1rem;
  }

  .right-wrapper {
    flex-direction: column;
    gap: 2rem;
  }

  .info-panel,
  .form-section {
    width: 100%;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .form-row {
    flex-direction: column;
    gap: 1rem;
  }

  .form-item input {
    font-size: 1rem;
  }

  .form-item label {
    font-size: 1.1rem;
  }

  .rich-editor {
    font-size: 1rem;
    min-height: 200px;
  }

  .placeholder-text {
    font-size: 1rem;
  }

  .submit-img {
    height: 40px;
  }
}
</style>
